import tagularModule from '../store/helpers/tagular'

const desktopMatcher = window.matchMedia('(min-width: 500px)')
const variationWrappers = document.getElementsByClassName(
  'amex-variation-wrapper'
)
const mobileVariations = document.querySelectorAll(`[data-amex-display=mobile]`)
const desktopVariations = document.querySelectorAll(
  `[data-amex-display=desktop]`
)

/**
  @param variation: string: v1 | v2 | v3 | v4 | none
*/
window.displayAmexBanner = function(variation) {
  if (desktopMatcher.matches) {
    displayDesktopBanners()
  } else {
    displayMobileBanners()
  }

  for (let i = 0; i < variationWrappers.length; i++) {
    variationWrappers[i].classList.add('+display-none')
  }

  if (variation !== 'none') {
    const selectedVariation = document.querySelector(
      `[data-amex-variation=${variation}]`
    )
    selectedVariation.classList.remove('+display-none')
  }
}

const matches = function(desktopMatcher) {
  if (desktopMatcher.matches) {
    displayDesktopBanners()
    return
  }

  displayMobileBanners()
}

desktopMatcher.addEventListener('change', matches)

function displayMobileBanners() {
  for (let i = 0; i < desktopVariations.length; i++) {
    desktopVariations[i].classList.add('+display-none')
  }
  for (let i = 0; i < mobileVariations.length; i++) {
    mobileVariations[i].classList.remove('+display-none')
  }
}

function displayDesktopBanners() {
  for (let i = 0; i < mobileVariations.length; i++) {
    mobileVariations[i].classList.add('+display-none')
  }
  for (let i = 0; i < desktopVariations.length; i++) {
    desktopVariations[i].classList.remove('+display-none')
  }
}

function bindClickTracking() {
  const variations = [...mobileVariations, ...desktopVariations]
  for (let i = 0; i < variations.length; i++) {
    const element = variations[i]

    element.addEventListener('click', () => {
      tagularModule.elementClicked(
        {
          htmlId: element.id,
          elementType: 'button',
          location: 'amex_ad',
          position: 'inline',
          text: element.dataset['trackingText']
        },
        'Amex Link',
        element.href
      )
    })
  }
}

function bindElementViewedTracking(elements) {
  // iterate through our display banners
  for (let i = 0; i < elements.length; i++) {
    const current = elements[i]

    if (
      current.getBoundingClientRect().y < window.innerHeight &&
      !current.getAttribute('data-element-viewed') &&
      !current.classList.contains('+display-none')
    ) {
      // fire event
      tagularModule.elementViewed({
        elementType: 'inline_ad',
        htmlId: 'amex_ad_platform_assets',
        location: 'amex_ad',
        position: 'inline',
        text: 'Learn_more'
      })

      // add data attr so event only fires once
      current.setAttribute('data-element-viewed', 'true')
    }
  }
}

window.addEventListener('scroll', () => {
  bindElementViewedTracking(variationWrappers)
})

bindClickTracking()
